<template>
<div class="feature-section">

    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <h2 class="text-center hk-heading my-4">Our Core Features Driving Hospitality Excellence</h2>
            </div>
        </div>
    </div>
    <div class="container">
        <div id="featureCarousel" class="carousel slide " data-bs-ride="carousel" :data-bs-interval="carouselInterval" @slide.bs.carousel="handleSlide">
           

            <div class="carousel-inner">
                <!-- Desktop View -->
                <div class="carousel-item" :class="{ active: index === activeIndex }" v-for="(cardGroup, index) in groupedCards" :key="index" v-if="!isMobile">
                    <div class="row">
                        <div class="col-md-4 mt-3 mb-3" v-for="(card, idx) in cardGroup" :key="idx">
                            <div class="card">
                                <div class="card-body">
                                    <div class="gray-box mb-3 p-4 ">
                                        <img :src="card.icon" alt="Feature Icon" class=" mb-3" loading="lazy"/>
                                        <h3 class="mb-3 hk-miniheading"> {{ card.title }}</h3>
                                        <p class="hk-micro-text">{{ card.text }}</p>
                                    </div>
                                    <div class="card-sub-body p-4">
                                        <h5 class="bullet-head pb-4 mb-0">Popular Features:</h5>
                                        <div class="bullet-box mb-2" v-for="(item, itemIdx) in card.items" :key="itemIdx">
                                            <img src="@/assets/home/check_green_circle.svg" alt="Check" loading="lazy" />

                                            <p class="mb-0"> {{ item }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- Mobile View -->
                <div class="carousel-item" :class="{ active: index === activeIndex }" v-for="(card, index) in allCards" :key="index" v-if="isMobile">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-body">
                                    <h3><i :class="card.icon"></i> {{ card.title }}</h3>

                                    <p>{{ card.text }}</p>
                                    <hr />
                                    <h5>{{ card.heading }}</h5>
                                    <ul>
                                        <li v-for="(item, itemIdx) in card.items" :key="itemIdx" class="">
                                            <img src="@/assets/home/check_green_circle.svg" alt="Check" class="me-2" />
                                            {{ item }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             <!-- Indicators -->
            <div class="carousel-indicators" v-if="!isMobile">
                <button v-for="(cardGroup, index) in groupedCards" :key="index" type="button" data-bs-target="#featureCarousel" :data-bs-slide-to="index" :class="{ active: activeIndex === index }" :aria-label="'Slide ' + (index + 1)"></button>
            </div>

            <!-- Navigation Buttons -->
            <!-- Navigation Buttons -->
            <div class="button-container" v-if="!isMobile">
                <button class="carousel-control-prev" type="button" data-bs-target="#featureCarousel" data-bs-slide="prev">
                    <i class="fas fa-chevron-left"></i>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#featureCarousel" data-bs-slide="next">
                    <i class="fas fa-chevron-right"></i>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>

        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "FeatureSections",
    data() {
        return {
            activeIndex: 0,
            isMobile: window.innerWidth <= 768,
            carouselInterval: 5000,
            allCards: [{
                    icon: require('@/assets/home/feature-icon/optimized-revenue.svg'),
                    title: "Optimized Revenue",
                    text: "Maximize profits with data-driven pricing and automated strategies.",
                    items: [
                        "Maximize revenue with real-time, data-driven pricing strategies.",
                        "Streamline onboarding for faster operational efficiency.",
                        "Simplify operations with a unified, single-stack solution.",
                    ],
                },
                {
                    icon: require('@/assets/home/feature-icon/comprehensive-frontdesk.svg'),
                    title: "Comprehensive Frontdesk",
                    text: "Deliver exceptional guest experiences with all in one dashboard.",
                    items: [
                        "Digital check-ins & payments for seamless guest management.",
                        "Integrated ID scanning & folios for added convenience.",
                        "Easy upgrades and upsells to boost revenue.",
                    ],
                },
                {
                    icon: require('@/assets/home/feature-icon/smart-crs.svg'),
                    title: "Smart CRS",
                    text: "Real-time booking management across multiple channels.",
                    items: [
                        "Real-time inventory management across all channels.",
                        "Direct OTA and GDS connections for maximum exposure.",
                        "Private APIs for instant rate updates on external platforms.",
                    ],
                },
                {
                    icon: require('@/assets/home/feature-icon/advanced-pos.svg'),
                    title: "Advanced POS",
                    text: "Streamlines transactions, and boosts efficiency in retail and restaurants.",
                    items: [
                        "Integrated kiosks & order management for seamless operations.",
                        "Kitchen Display System & Order App for streamlined operations.",
                        "Payments, inventory, & real-time analytics for better performance.",
                    ],
                },
                {
                    icon: require('@/assets/home/feature-icon/inventory-management.svg'),
                    title: "Inventory Management",
                    text: "Inventory management supports basic, composite, and variant products for seamless operations.",
                    items: [
                        "Manage inventory seamlessly on desktop or mobile.",
                        "Predictive purchase orders and automated vendor management.",
                        "Real-time sales and inventory dashboards on any device.",
                    ],
                },
                {
                    icon: require('@/assets/home/feature-icon/multi-platform-reporting.svg'),
                    title: "Multi-Platform Reporting",
                    text: "Multi-platform reporting delivers reports anytime, anywhere on the web and mobile.",
                    items: [
                        "Real-time reports in Excel and PDF formats.",
                        "Automated email report scheduling.",
                        "Dynamic reporting with filters, charts, and export options.",
                    ],
                },
                {
                    icon: require('@/assets/home/feature-icon/real-time-analytics.svg'),
                    title: "Real-time Analytics ",
                    text: "Analytics and portfolio dashboards offer a consolidated view of critical metrics.",
                    items: [
                        "Manage operations and revenue via Manager App on mobile.",
                        "Access real-time data and receive instant alerts.",
                        "Analyze operational portfolio data for better decision-making.",
                    ],
                },
                {
                    icon: require('@/assets/home/feature-icon/simplify-payments.svg'),
                    title: "Simplify Payments",
                    text: "Helps with automated batch closing for seamless transactions.",
                    items: [
                        "PCI-compliant P2PE with EMV, Apple, and Google Pay support.",
                        "Seamless integration with Shift4, FreedomPay, and Elavon.",
                        "Detailed transaction and refund reports.",
                    ],
                },
                {
                    icon: require('@/assets/home/feature-icon/digitalised-housekeeping.svg'),
                    title: "Housekeeping & Maintenance",
                    text: "Smart housekeeping with real-time updates and messaging between systems.",
                    items: [
                        "Automate task schedules, assignments, & real-time updates.",
                        "Staff manage tasks efficiently via mobile app.",
                        "Mark maintenance with inventory adjustments & guided workflows.",
                    ],
                },
                {
                    icon: require('@/assets/home/feature-icon/event-management.svg'),
                    title: "Event Management",
                    text: "Simplifies management of small, midscale, or large events.",
                    items: [
                        "Manage spaces, packages, and sub-events with real-time updates.",
                        "Attach flexible cancellation terms and automate fees.",
                        "Simplify invoicing, payments, and reporting for any event scale.",
                    ],
                },
                {
                    icon: require('@/assets/home/feature-icon/efficient-booking-module.svg'),
                    title: "Efficient Booking Module",
                    text: "Effortlessly handles all aspects of booking operations with efficiency.",
                    items: [
                        "Effortless group check-ins & rooming lists with guided workflows.",
                        "Flexible billing with automated folios for payments.",
                        "Dynamic group types with tailored booking processes.",
                    ],
                },
                {
                    icon: require('@/assets/home/feature-icon/corporate-accounts.svg'),
                    title: "Corporate Accounts",
                    text: "Maintains records of all enterprise and local corporate account information.",
                    items: [
                        "Automate invoicing with digital delivery and scheduled billing.",
                        "Support bulk & partial settlements with direct bill & credit limits.",
                        "Configure rates, credit terms, & invoicing for corporate accounts.",
                    ],
                },
                {
                    icon: require('@/assets/home/feature-icon/training-modules.svg'),
                    title: "Training Modules",
                    text: "Self-guided training tool, designed for independent learning.",
                    items: [
                        "AI-guided, on-demand training for faster staff readiness.",
                        "Embedded tooltips, alerts, and notifications for real-time help.",
                        "AI insights optimize user experience and training paths.",
                    ],
                },
                {
                    icon: require('@/assets/home/feature-icon/activity-management.svg'),
                    title: "Activity Management",
                    text: "Seamlessly organize, schedule, and track activities in one place.",
                    items: [
                        "Direct API integration with PMS for seamless activity reservations.",
                        "Centralized platform for real-time availability and pricing.",
                        "Secure gateway integration for automated confirmations & reporting.",
                    ],
                },
                {
                    icon: require('@/assets/home/feature-icon/tenant-management.svg'),
                    title: "Tenant Management",
                    text: "Simplify student housing with easy leasing, and digital management.",
                    items: [
                        "Manage tenant profiles, leases, & communication through a unified platform.",
                        "Simplify rent collection with automated reminders & receipts.",
                        "Track occupancy rates, payment histories, with insightful reports.",
                    ],
                },

            ],
        };
    },
    computed: {
        groupedCards() {
            let groups = [];
            for (let i = 0; i < this.allCards.length; i += 3) {
                groups.push(this.allCards.slice(i, i + 3));
            }
            return groups;
        },
    },
    methods: {
        handleSlide(event) {
            const items = Array.from(document.querySelectorAll(".carousel-item"));
            const index = items.indexOf(event.relatedTarget);
            this.activeIndex = index;
        },
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        },
    },
    mounted() {
        window.addEventListener("resize", this.checkMobile);
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.checkMobile);
    },

};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/config/variables.scss";
@import "@/assets/sass/main.scss";

ul {
    list-style-type: none;
}

.bullet-head {
    color: #000;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
}

.bullet-point {
    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
}

ul {
    line-height: 35px;
}

.gray-box {
    border-radius: 14px;
    background: #FAFAFA;
    padding: 3px;
    border: 2px solid #d9d9d934;
    height: 220px;
    color: #333;
}

.carousel-control-prev,
.carousel-control-next {
    width: 30px;
    height: 30px;
    background-color: rgb(189, 189, 189);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    margin-top: 15rem;
    /* margin: -4rem; */
    margin-left: -2rem;
    margin-right: -2rem;

}

.carousel-control-prev:hover,
.carousel-control-next:hover {
    background-color: #555;
}

.carousel-indicators button {
    background-color: #454545;
    border: none;
    width: 7px;
    height: 7px;
    border-radius: 100%;
    margin: 0 7px;
}

.carousel-indicators {
    position: relative;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
    display: flex;
    justify-content: center;
    padding: 0;
    margin-right: 15%;
    margin-bottom: 1rem;
    margin-left: 15%;
}

.card-body {
    flex: 1 1 auto;
    color: var(--bs-card-color);
    height: 575px;
}

.card {
    --bs-card-border-color: var(--bs-border-color-white);
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

.bullet-box {
    font-family: inter;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10px;
}

@media (max-width: 768px) {
    .carousel-indicators {
        display: none;
    }

    .carousel-control-prev[data-v-2dfbef44],
    .carousel-control-next[data-v-2dfbef44] {
        width: 35px;
        height: 30px;
        background-color: #f3f3f3;
        border-radius: 6%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        margin-top: 26rem;
        margin-left: 20rem;
        margin-right: 0rem;
    }

    .card-body {
        flex: 1 1 auto;
        color: var(--bs-card-color);
        height: 375px;
    }
}
</style>
